<template>
  <div class="advanced-filters">
    <div
      v-for="(filter, index) in filters"
      :key="index"
      class="row d-flex align-items-center"
    >
      <div class="col-md-3">
        <multiselect
          :options="filterable"
          label="label"
          track-by="name"
          v-model="filter.column"
          @input="handleColumnInput($event, filter)"
          :show-labels="false"
        ></multiselect>
      </div>
      <div class="col-md-2">
        <multiselect
          label="label"
          track-by="value"
          :disabled="filter.disabledOperator"
          :options="filter.operatorOptions"
          v-model="filter.operator"
          @input="handleOperatorInput($event, filter)"
          :show-labels="false"
        ></multiselect>
      </div>
      <div class="col-md-7 d-flex justify-content-between align-items-center">
        <multiselect
          v-if="filter.showMultiselect"
          :disabled="filter.disabledInput"
          :loading="false"
          :options="filter.options"
          label="option_name"
          :internal-search="true"
          v-model="filter.value"
          :multiple="true"
          track-by="option_id"
          @search-change="handleSearchChange($event, filter)"
          :show-labels="false"
          :show-no-options="false"
          :placeholder="
            !filter.disabledInput ? $gettext('Type to Search...') : ''
          "
          :taggable="true"
          @tag="handleFilterValueTag($event, filter)"
        >
          <span slot="noResult"><translate>No results</translate></span>
        </multiselect>
        <BFormInput
          v-else-if="filter.showDatePicker"
          type="date"
          v-model="filter.value"
        ></BFormInput>
        <div v-else-if="filter.showDateRangePicker" class="row w-100">
          <div class="col-md-6">
            <b-input-group :prepend="$gettext('from')" class="mb-0">
              <BFormInput type="date" v-model="filter.value.start"></BFormInput>
            </b-input-group>
          </div>
          <div class="col-md-6">
            <b-input-group :prepend="$gettext('to')" class="mb-0">
              <BFormInput type="date" v-model="filter.value.end"></BFormInput>
            </b-input-group>
          </div>
        </div>
        <BButton
          variant="danger"
          pill
          @click="handleDeleteFilter(index)"
          class="btn-icon btn-sm ml-3"
        >
          <i class="fas fa-times"></i>
        </BButton>
      </div>
    </div>
    <div class="row">
      <div class="col-md text-right">
        <BButton variant="default" @click="addFilter" class="mr-2">
          <i class="fas fa-plus mr-2"></i>
          <translate>Add filter</translate>
        </BButton>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { createFilter } from "./filters";
import translate from "./Translate.vue";
import { BButton, BFormInput } from "bootstrap-vue";

export default {
  components: { Multiselect, translate, BButton, BFormInput },
  props: {
    schema: {
      required: true,
      type: [Array, Object]
    },
    savedFilters: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  data() {
    return { filters: [] };
  },
  computed: {
    filterable() {
      return this.schema.filter(filter => filter.is_filterable);
    }
  },
  methods: {
    handleFilterValueTag(tag, filter) {
      filter.value.push({
        option_id: tag,
        option_name: tag
      });
    },
    toRequest(filter) {
      return {
        field: filter.column.name || null,
        operator: filter.operator?.value || null,
        value: filter.value || null
      };
    },
    addFilter() {
      return this.filters.push(createFilter());
    },
    handleColumnInput(column, filter) {
      filter.setColumn(column);
    },
    handleOperatorInput(operator, filter) {
      filter.setOperator(operator);
    },
    handleSearchChange(q, filter) {
      if (filter.column.isEndpointOption) {
        const url = `ats/${filter.column.options.endpoint}?name=${filter.column.name}&q=${q}`;
        this.$http.get(url).then(({ data }) => (filter.options = data));
      }
    },

    async handleDeleteFilter(index) {
      this.filters.splice(index, 1);
    }
  },
  watch: {
    savedFilters: {
      handler(filters) {
        this.filters = filters;
      },
      deep: true
    },
    filters: {
      handler(filters) {
        this.$emit("filterschange", filters.map(this.toRequest));
      },
      deep: true
    }
  }
};
</script>
